declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

// GTM's "CE - sign_up" trigger listens for this event; GA4 forwards it as sign_up.
const SIGN_UP_EVENT = "sign_up";
const SIGN_UP_TRACKED_KEY_PREFIX = "ga4SignUpTracked:";

// Sign-ups complete via two paths that both end in a session fetch: the email
// form (signup → signin → session) and the Google OAuth round-trip, where the
// app only ever sees the established session. Neither path carries an explicit
// "account was just created" signal, so a session whose user was created within
// this window is treated as a fresh signup. Generous to absorb client clock
// skew; the per-user guard below is what prevents duplicates.
const FRESH_ACCOUNT_WINDOW_MS = 15 * 60 * 1000;

/**
 * Push a GA4 `sign_up` event for a freshly created account, exactly once.
 * Call whenever a session is established; logins and reloads are no-ops
 * because the account is old or the event was already sent for this user.
 */
export const trackSignUpIfNewAccount = (user: { id?: string; createdAt?: string } | null | undefined): void => {
  if (!user?.id || !user.createdAt) return;

  const accountAge = Date.now() - new Date(user.createdAt).getTime();
  if (Number.isNaN(accountAge) || accountAge > FRESH_ACCOUNT_WINDOW_MS) return;

  const guardKey = `${SIGN_UP_TRACKED_KEY_PREFIX}${user.id}`;
  try {
    if (localStorage.getItem(guardKey)) return;
    localStorage.setItem(guardKey, new Date().toISOString());
  } catch {
    // localStorage unavailable — send anyway rather than lose the signup.
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: SIGN_UP_EVENT });
};
